import { isBrowser } from "@/lib/utils"
import Breadcrumb from "@/modules/productPc/Breadcrumb"
import React, { FC, useEffect, useState } from "react"
import * as Styles from './article-detail.module.scss'
import SEO from './seo'

const ArticleDetail = ({ pageContext, id }) => {
  const [breadCrumbList, setBreadCrumbList] = useState(() => {
    return [
      { path: '/', term: '首页' },
      { path: '/articles', term: '文章精选' },
      { path: `/article/${id || pageContext.id}`, term: decodeURIComponent(title || pageContext.title) },
    ]
  })

  const [title, setTitle] = useState()

  function loaded() {
    const by_iframe = document.querySelector('#by_iframe')
    if (by_iframe.contentWindow?.document?.title) {
      setTitle(by_iframe.contentWindow.document.title)

      setBreadCrumbList([
        { path: '/', term: '首页' },
        { path: '/articles', term: '文章精选' },
        { path: `/article/${id || pageContext.id}`, term: decodeURIComponent(by_iframe.contentWindow.document.title || pageContext.title) },
      ])
    }
  }

  return <section className={Styles.articleDetail}>
    <SEO
      title={'别样海外购_用户文章详情频道 | 别样海外购 bieyangapp.com'}
      description={`别样海外购_用户文章详情频道 | ${decodeURIComponent(title || pageContext.title)} | 别样海外购 bieyangapp.com`}
      keywords={`别样海外购_用户文章详情频道 | ${decodeURIComponent(title || pageContext.title)} | 别样海外购 bieyangapp.com`}
    />
    <Breadcrumb cate={breadCrumbList} />
    {(title || pageContext.title) && <div className={Styles.title}>{decodeURIComponent(title || pageContext.title)}</div>}
    <iframe
      // src={`https://bieyangapp.com/curation/${id}/`}
      id='by_iframe'
      src={`https://baleen-cdn-g.bybieyang.com/static/curation/${id || pageContext.id}/${id || pageContext.id}.html?v=132`}
      // src={`https://baleen-dev-cdn-g.bybieyang.com/static/curation/${id || pageContext.id}/${id || pageContext.id}.html?v=132`}
      frameBorder="0"
      width={'100%'}
      height={'100%'}
      scrolling="yes"
      onLoad={loaded}
    ></iframe>
  </section>
}

export default ArticleDetail